import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslatePipe } from "@ngx-translate/core";
import { FrontendReport } from "@partikelart/portal/shared-typing";
import { ExportSplitButtonComponent } from "@partikelart/portal/ui";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { Observable } from "rxjs";
import { getAllReportForSelectedParts } from "../+state/export.actions";
import { reportsLoading, selectedReports } from "../+state/export.selectors";
import { DataExportService, OutputFilenameIdentifier } from "../data-export.service";
import { MultiExportReportTableComponent } from "../multi-export-report-table/multi-export-report-table.component";

@Component({
	selector: "partikelart-multi-export-table-page",
	templateUrl: "./multi-export-table-page.component.html",
	styleUrls: ["./multi-export-table-page.component.scss"],
	standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		CardModule,
		ButtonModule,
		TranslatePipe,
		ExportSplitButtonComponent,
		MultiExportReportTableComponent,
		ExportSplitButtonComponent,
	],
})
export class MultiExportTablePageComponent implements OnInit {
	currentSelectedReportsForExport: FrontendReport[] = [];
	reportData$: Observable<FrontendReport[]>;
	reportsLoading$: Observable<boolean>;
	constructor(
		private exportService: DataExportService,
		private store: Store,
	) {
		this.reportData$ = this.store.select(selectedReports);
		this.reportsLoading$ = this.store.select(reportsLoading);
	}

	ngOnInit(): void {
		this.exportService.setCurrentStep(1);
		// Initally it is set to use all export data
		this.store.dispatch(getAllReportForSelectedParts());
		//Note the Spread Operator is needed, because the data from the store is immutable if not copied
		this.reportData$.subscribe((data) => (this.currentSelectedReportsForExport = [...data]));
	}
	exportCurrent() {
		this.exportService.exportCurrent();
	}
	selectedReportsChange(event: FrontendReport[]) {
		//Note the Spread Operator is needed, because the data from the store is immutable if not copied
		this.currentSelectedReportsForExport = [...event];
	}
	downloadReports(option = "xlsx") {
		this.exportService.reportDataToFile(
			this.currentSelectedReportsForExport,
			option,
			OutputFilenameIdentifier.SpecNumber,
		);
	}
}
